import { PageType } from '.'
import { useTranslation } from 'react-i18next'

type ConfigOptions = {
  title?: string
  description?: string
  buttonText?: string
  destination?: string
}

export const staticSignUpConfig: Record<PageType, ConfigOptions> = {
  gm: {
    destination: '/office-catering/vendors',
  },
  cc: {
    destination: '/authentication/cloud-canteen-signup-finish',
  },
}

export const useSignUpConfig = () => {
  const { t } = useTranslation()
  const config: Record<PageType, ConfigOptions> = {
    gm: {
      title: t('authentication:gm.title'),
      description: t('authentication:gm.description'),
      buttonText: t('authentication:gm.buttonText'),
    },
    cc: {
      title: t('authentication:cc.title'),
      description: t('authentication:cc.description'),
      buttonText: t('authentication:cc.buttonText'),
    },
  }
  return config
}
